import { FormProvider, UseFormReturn } from 'react-hook-form';
import FormBuilderWithLayout, { FormField } from '@/components/company/FormBuilderWithLayout';
import { IReward } from '@/states/reward.state';

interface RewardFormProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formControl: UseFormReturn<IReward> & Record<string, any>;
  formRef: React.RefObject<HTMLFormElement>;
  fields: FormField[];
  handleSave: (data: IReward) => void;
  disabled?: boolean;
}

export const RewardForm = ({ formControl, formRef, fields, handleSave, disabled }: RewardFormProps) => {
  return (
    <FormProvider {...formControl}>
      <form ref={formRef} onSubmit={formControl.handleSubmit(handleSave)} className="mt-2">
        <FormBuilderWithLayout fields={fields} showPublishButton={false} disabled={disabled} columns={1} />
      </form>
    </FormProvider>
  );
};
